import { DEFAULT_ROUTE, PROTECTED_ROLE_LINKS } from 'constants/dashboard';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { isUserStorageProvider } from 'services/userService';
import { useUserContext } from 'state/contexts/userContext/userContext';

const RedirectIfNotStorageProvider: FC = ({ children }) => {
  const router = useRouter();

  const {
    user: { userData },
  } = useUserContext();

  const [isInit, setIsInit] = useState(true);

  const isStorageProviderProtectedRoute = PROTECTED_ROLE_LINKS.some(
    (route) => route === router.pathname,
  );

  useEffect(() => {
    if (
      userData !== null &&
      !isUserStorageProvider(userData) &&
      isStorageProviderProtectedRoute
    ) {
      router.push(DEFAULT_ROUTE);
    } else {
      setIsInit(false);
    }
  }, [userData, router, isStorageProviderProtectedRoute]);

  return isInit ? null : <>{children}</>;
};

export default RedirectIfNotStorageProvider;
